import { IMeta } from '@shared/types'

export const getRandomReviewCount = () => Math.floor(Math.random() * (700 - 200 + 1)) + 200

export const getBreadcrumbJson = ({ h1 }: Pick<IMeta, 'h1'>) =>
  JSON.stringify({
    '@context': 'http://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Главная 🎮',
        item: 'https://payment.mts.ru/cyber/',
      },
      h1 && {
        '@type': 'ListItem',
        position: 2,
        name: h1,
        item: '',
      },
    ].filter(Boolean),
  })

export const getProductJson = ({
  title,
  description,
  id,
  reviewCount,
}: Pick<IMeta, 'title' | 'description' | 'id'> & { reviewCount: number }) =>
  JSON.stringify({
    '@context': 'http://schema.org/',
    '@type': 'Product',
    name: title,
    image: ['https://staticpayment.ssl.mts.ru/img/MTCoplata/apple-touch-icon.png'],
    description,
    brand: {
      '@type': 'Brand',
      name: 'MTC Оплата',
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: 5,
      reviewCount,
    },
    url: `https://payment.mts.ru/cyber${id}`,
  })
